import { APP_INITIALIZER, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ChatBotService } from './chat-bot.service'

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (chatBotService: ChatBotService) => () => chatBotService,
      deps: [ChatBotService],
      multi: true
    }
  ]
})
export class ChatBotModule {
}

